import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

const CartContext = createContext(null);
const KEY = "wbg_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      return [...prev, {
        product_id: product.id, slug: product.slug, name: product.name, type: product.type,
        price: product.price, cover_image: product.cover_image, requires_shipping: product.requires_shipping,
        quantity: qty,
      }];
    });
    api.post("/events", { event_type: "add_to_cart", data: { product_id: product.id, slug: product.slug } }).catch(() => {});
    toast.success(`${product.name} added to cart`);
  };

  const remove = (productId) => setItems((prev) => prev.filter((i) => i.product_id !== productId));
  const setQty = (productId, qty) => setItems((prev) => prev.map((i) => i.product_id === productId ? { ...i, quantity: Math.max(1, qty) } : i));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const hasPhysical = items.some((i) => i.requires_shipping);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal, hasPhysical }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
